import {createActionWithoutPayload, createActionWithPayload} from "./utils";
import {Logs} from "../types";


export const [getLogs, isGetLogsAction ] = createActionWithoutPayload('GET_LOGS');
export const [logsError, isLogsError ] = createActionWithoutPayload('LOGS_ERROR');
export const [getLogsSuccess, isGetLogsSuccess ] = createActionWithPayload<Logs[]>('GET_LOGS_SUCCESS');
